import { Dialog, DialogActions, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import React from 'react'
import AppBarModal from '../../general/AppBarModal';
import TareasTerminadas from '../../general/TareasTerminadas';
import { BtnForm } from '../../general/BotonesAccion';
import { consulta } from '../../../global/js/funciones';

const ModalEditarPeriodo = ({ modalEditarPeriodo, mostrarModalEditarPeriodo, actualizarMensaje, validacion, periodos = [], actualizarDataValidaciones }) => {

    const [cargando, setCargando] = React.useState(false);
    const [periodo, setPeriodo] = React.useState('');
    const [validacionActual, setValidacionActual] = React.useState({});

    React.useEffect(() => {
        setPeriodo('');
        setValidacionActual(validacion ?? {});
    }, [validacion?.id]);

    const handleGuardar = () => {
        if (!periodo) return actualizarMensaje({ titulo: 'Por favor selecciona el periodo', tipo: 'info', mostrar: true, tiempo: 6000 });
        setCargando(true);
        consulta(`api/v1.0/validaciones/actualizar_periodo/${validacionActual.id}`, { periodo }, 'PUT', (error, estado, resp) => {
            if (estado === 200) {
                actualizarDataValidaciones();
                actualizarMensaje({ titulo: 'Periodo actualizado', tipo: 'success', mostrar: true, tiempo: 6000 });
                mostrarModalEditarPeriodo(false);
            } else if (estado === 302) actualizarMensaje({ titulo: resp.titulo, tipo: 'warning', mostrar: true, tiempo: 6000 });
            else actualizarMensaje({ titulo: 'Error al actualizar el periodo', tipo: 'error', mostrar: true, tiempo: 6000 });
            setCargando(false);
        });
    }

    return (
        <Dialog open={modalEditarPeriodo} maxWidth="xs" fullWidth={true} onClose={() => mostrarModalEditarPeriodo(false)}>
            <AppBarModal titulo='¡ Editar Periodo de la Solicitud !' mostrarModal={mostrarModalEditarPeriodo} titulo_accion='' />
            <DialogContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }} className='scroll' >
                {
                    cargando ?
                        <TareasTerminadas mensaje='Cargando...' marginTop='5%' />
                        :
                        <Grid item xs={12} md={12}>
                            <Typography variant='body2' color='textSecondary' style={{ marginBottom: 10 }}>
                                {`Periodo actual: ${validacionActual.periodo ?? ''}`}
                            </Typography>
                            <FormControl className='form-control'>
                                <InputLabel htmlFor="periodo">Seleccione Periodo</InputLabel>
                                <Select
                                    inputProps={{
                                        name: 'periodo',
                                        id: 'periodo',
                                    }}
                                    value={periodo}
                                    onChange={({ target }) => setPeriodo(target.value)}
                                    required={true}
                                >
                                    {periodos.filter(({ periodo }) => periodo && `${periodo}` != `${validacionActual.periodo}`).map(({ periodo }, i) => <MenuItem key={i} value={periodo}>{periodo}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                }
            </DialogContent>
            <DialogActions>
                <BtnForm texto="Guardar" callback={() => handleGuardar()} />
                <BtnForm texto="Cerrar" callback={() => mostrarModalEditarPeriodo(false)} />
            </DialogActions>
        </Dialog>
    )
}

export default ModalEditarPeriodo
